// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color, styledScrollbar } from "@awc/XDL/Utilities";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import MenuDefaultProps from "@insite/mobius/Menu/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...MenuDefaultProps,
        mergeCss: true,
        moreIconProps: {
            css: css`
                display: none;
            `,
        },
        menuItemTypographyProps: {
            size: fontConfig.fontSize.small,
            weight: fontConfig.weight.regular,
            lineHeight: fontConfig.lineHeight.singleLineSmall,
        },
        cssOverrides: {
            menu: css`
                padding: 6px 0;
                height: 100%;
                max-height: calc(80vh - var(--headerHeight));
                box-shadow: 1px 0 0 0 ${color("common.border")};
                ${styledScrollbar(8)}

                & > .MenuItem[data-open] {
                    background: ${color("primary")};

                    ${TypographyStyle}, ${IconWrapper} {
                        color: ${color("common.ui1")};
                    }
                }

                ${({ referenceIndex }: any) => {
                    if (referenceIndex === 0) {
                        return css`
                            width: 445px;
                            position: relative;
                            &:after {
                                content: "";
                                position: absolute;
                                width: 1px;
                                height: 100%;
                                background: ${color("common.border")};
                                top: 0;
                                right: 0;
                            }
                        `;
                    }
                    return css`
                        width: 330px;
                    `;
                }}
            `,
            menuItem: css`
                ${StyledButton} {
                    padding: 6px 12px;
                    min-height: initial;
                    &:hover,
                    &:focus {
                        background: ${color("primary")};

                        ${TypographyStyle}, ${IconWrapper} {
                            color: ${color("common.ui1")};
                        }
                    }
                }
            `,
            viewAllItem: css`
                ${StyledButton} {
                    padding: 6px 12px;
                    min-height: initial;
                    &,
                    ${TypographyStyle} {
                        color: ${color("primary.main")};
                        font-weight: ${fontConfig.weight.bold};
                    }
                    &:focus {
                        ${TypographyStyle}, ${IconWrapper} {
                            color: ${color("common.ui8")};
                        }
                    }
                    &:hover {
                        background: ${color("common.ui1")};

                        ${TypographyStyle}, ${IconWrapper} {
                            color: ${color("common.ui8")};
                        }
                    }
                }
            `,
        },
        menuTitleProps: {
            css: css`
                color: ${color("secondary.main")};
                font-size: ${fontConfig.fontSize.small}px;
                line-height: ${fontConfig.lineHeight.singleLineSmall};
                font-weight: ${fontConfig.weight.bold};
                padding: 6px 12px;
            `,
        },
        viewAllProps: {
            color: "secondary.main",
            css: css`
                padding: 6px 12px;
            `,
        },
    },
} as xBaseTheme["menu"];
